<div class="d-flex justify-content-between align-items-center">

  <h6>Return the Proposal</h6>

  <button type="button" class="btn-close" aria-label="Close" (click)="closeRejectDialog()"></button>
</div>

<div class="row">

  <form [formGroup]="returnLoanForm" (ngSubmit)="submitReturnReason(returnLoanForm.value)" >
    <div class="col-12 d-flex flex-wrap">
      <div class="col-md-12">
        <mat-form-field appearance="outline" class="example-full-width w-100 me-4">
          <mat-label>Reason for Return</mat-label>
          <mat-select formControlName="reasonType" required >
            <mat-option *ngFor="let type of returnReasonArr" [value]="type.id">
              {{ type.reason }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

      <div class="col-md-12" *ngIf="returnLoanForm?.controls['reasonType'].value == 8">
        <mat-form-field appearance="outline" class="example-full-width w-100 me-4">
          <mat-label>Reason for return</mat-label>
          <input matInput type="text" formControlName="rejectedReason" placeholder="Enter Reason for return" required>
        </mat-form-field>

      </div>
    </div>

    <div class="col-12 text-end">
      <button type="submit" class="btn add-btn" [disabled]="returnLoanForm?.invalid">SUBMIT</button>
    </div>
  </form>
</div>
